import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringifiedDate',
})
export class StringifiedDatePipe extends DatePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) locale: string) {
    super(locale);
  }

  transform(value: any, format?: string, timezone?: string, locale?: string): string {
    const date = new Date(value);
    format = format || 'yyyy-MM-dd HH:mm:ss';
    return super.transform(date, format, timezone, locale);
  }
}
